type TEnvironment = 'local' | 'dev' | 'production'

const LOCAL_API_URL = 'http://localhost:8000/api/v1'

const trimTrailingSlash = (url: string): string => url.replace(/\/$/, '')

const getEnvMode = (): TEnvironment => (import.meta.env.VITE_APP_ENV_MODE || 'local') as TEnvironment

export const getBaseApiURL = (): string => {
  const apiBaseUrl = import.meta.env.VITE_API_BASE_URL
  if (typeof apiBaseUrl === 'string' && apiBaseUrl.length > 0) {
    return trimTrailingSlash(apiBaseUrl)
  }

  if (getEnvMode() === 'local') {
    return LOCAL_API_URL
  }

  throw new Error('VITE_API_BASE_URL is required for non-local builds. Set it in Amplify / Azure / .env.')
}

export const isLocal = () => getEnvMode() === 'local'

export const isDev = () => getEnvMode() === 'dev'

export const isProd = () => getEnvMode() === 'production'
